import type { Resource, ResourceLanguage } from 'i18next';

const modules: Record<string, ResourceLanguage> = import.meta.glob('./*/*.json', {
  eager: true,
  import: 'default',
});

const languageMap: Resource = {};

const reg = /\/(.+?)\/(.+?)\.json/;

for (const k in modules) {
  const [, locale, namespace] = reg.exec(k)!;
  const locales = languageMap[locale] || (languageMap[locale] = {});
  locales[namespace] = modules[k];
}

export default languageMap;
